// src/Dashboard/pages/user/PrepaPhysique/components/PrepaPhysiqueFilters.jsx

import React from "react";
import { FaFilter, FaSearch, FaTimes } from "react-icons/fa";

export default function PrepaPhysiqueFilters({
  filters,
  setFilters,
  programmes = [],
  loading,
  onReset,
}) {
  const fieldClass =
    "w-full rounded-2xl border border-slate-200 bg-white px-3 py-2 text-sm text-slate-900 outline-none transition focus:ring-2 focus:ring-indigo-400 disabled:opacity-60 dark:border-slate-700 dark:bg-slate-950 dark:text-white";

  const update = (patch) => {
    setFilters((previous) => ({
      ...previous,
      ...patch,
    }));
  };

  return (
    <div className="rounded-[24px] border border-slate-200 bg-slate-50 p-4 dark:border-slate-800 dark:bg-slate-900/60">
      <div className="mb-4 flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
        <div>
          <div className="inline-flex items-center gap-2 text-sm font-bold text-slate-900 dark:text-white">
            <FaFilter />
            Filtres exercices
          </div>

          <p className="mt-1 text-xs text-slate-500 dark:text-slate-400">
            Recherchez un exercice, filtrez par programme ou par état.
          </p>
        </div>

        <button
          type="button"
          onClick={onReset}
          className="inline-flex items-center justify-center gap-2 rounded-2xl bg-white px-3 py-2 text-xs font-bold text-slate-700 ring-1 ring-slate-200 transition hover:bg-slate-50 dark:bg-slate-950 dark:text-slate-200 dark:ring-slate-700 dark:hover:bg-slate-900"
        >
          <FaTimes />
          Réinitialiser
        </button>
      </div>

      <div className="grid grid-cols-1 gap-3 lg:grid-cols-4">
        <div className="lg:col-span-2">
          <label className="mb-1 block text-xs font-bold uppercase tracking-wide text-slate-500 dark:text-slate-400">
            Recherche
          </label>

          <div className="relative">
            <FaSearch className="pointer-events-none absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" />

            <input
              type="text"
              value={filters.search}
              onChange={(event) => update({ search: event.target.value })}
              disabled={loading}
              placeholder="Nom, programme, description..."
              className="w-full rounded-2xl border border-slate-200 bg-white py-2 pl-9 pr-3 text-sm text-slate-900 outline-none transition focus:ring-2 focus:ring-indigo-400 disabled:opacity-60 dark:border-slate-700 dark:bg-slate-950 dark:text-white"
            />
          </div>
        </div>

        <div>
          <label className="mb-1 block text-xs font-bold uppercase tracking-wide text-slate-500 dark:text-slate-400">
            Programme
          </label>

          <select
            value={filters.programme}
            onChange={(event) => update({ programme: event.target.value })}
            disabled={loading}
            className={fieldClass}
          >
            <option value="">Tous les programmes</option>

            {programmes.map((programme) => (
              <option key={programme} value={programme}>
                {programme}
              </option>
            ))}
          </select>
        </div>

        <div>
          <label className="mb-1 block text-xs font-bold uppercase tracking-wide text-slate-500 dark:text-slate-400">
            État
          </label>

          <select
            value={filters.status}
            onChange={(event) => update({ status: event.target.value })}
            disabled={loading}
            className={fieldClass}
          >
            <option value="all">Tous</option>
            <option value="todo">À faire</option>
            <option value="done">Réalisés</option>
          </select>
        </div>
      </div>
    </div>
  );
}